module.exports = __webpack_public_path__ + "static/media/hostelsclub.0c424759.jfif";